<div class="wrapper">
  <div class="container">
    <div class="circle-rotate">
      <div class="circle-rotate__rotating"></div>
      <div class="circle-rotate__static"></div>
    </div>
    <h2 class="heading__text--large"><ng-content></ng-content></h2>
  </div>
</div>
